import axios from '@/utilities/axios-global'

export function GET_PROFILE(context) {
  return new Promise((resolve, reject) => {
    axios.get(process.env.VUE_APP_API_BASE_URL + '/api/user/profile').then(response => {
      context.commit('SET_CLIENTS', response.data)
      context.commit('SET_NAME', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function CHANGE_PASSWORD() {
  const redirect = window.location.href
  axios.get(process.env.VUE_APP_API_BASE_URL + '/api/user/pwticket?redirect=' + redirect).then(response => {
    if (response.data.ticket) {
      window.location = response.data.ticket
    }
  }, error => {
    console.log(error)
  })
}

export function GET_PROFILEPHOTO(context, consultantNumber) {
  return new Promise((resolve, reject) => {
    let urlPath = process.env.VUE_APP_API_BASE_URL + '/api/user/' + consultantNumber + '/image'
    axios.get(urlPath).then((response) => {
      context.commit('SET_PROFILEPHOTO', response.data)
      resolve(resolve)
    }, (err) => {
      console.log(err)
      reject(reject)
    })
  })
}

export default {
  GET_PROFILE,
  CHANGE_PASSWORD,
  GET_PROFILEPHOTO
}
